<div class="row">
  <form class="form" [formGroup]="adminForm">
    <span><!-- Title --></span>
    <h2 i18n>Install Mods</h2>
    <span><!-- Description --></span>
    <p i18n>
      Quickly turn on and off mods bundled with this client.
      Visit the <a routerLink="../plugin">plugins</a> or
      <a routerLink="../template">templates</a> settings page to manage all
      plugins and templates.
    </p>

    <span><!-- Buttons --></span>
    <span class="buttons right floating top">
      @if (!modChangesLoaded() && !modChangesError().length) {
        <app-loading class="mod-changes-loading" [inline]="true" title="Checking mods for local changes..." i18n-title />
      } @else if (modChangesLoaded() && store.view.modUpdates().size) {
        <button type="button" (click)="updateAll()" i18n>🌟️ Update All</button>
      }
      @if (selectAllToggle()) {
        <button type="button" (click)="selectAll()" i18n>Select None</button>
      } @else {
        <button type="button" (click)="selectAll()" i18n>Select All</button>
      }
      <button type="button" (click)="install()" [disabled]="submitted() && !adminFormValid()" i18n>Save</button>
    </span>

    @if (hasLog()) {
      <span class="mobile-block"><!-- Log --></span>
      <div class="log mobile-block">
        <ng-container *ngTemplateOutlet="log" />
      </div>
    }

    @for (group of modGroups | keyvalue; track group.key) {
      <label [style.text-transform]="'capitalize'" i18n>{{ group.key }}</label>
      <div formGroupName="mods" class="bubble">
        @for (e of group.value; track e[0]) {
          @let key = e[0];
          @let c = e[1];
          @if (experiments || !c.config?.experimental || installed(c)) {
            <div [title]="c.config?.description || ''" class="mod-row nowrap" [class.deleted]="disabled(c)">
              <input id="mod-{{ modLabel(e) }}" type="checkbox" [formControlName]="key">
              <label for="mod-{{ modLabel(e) }}" [title]="c.config?.description || ''">{{ c.config?.mod || c.name || c.tag || 'root' }}@if (hasCustomChanges(c)) {<span class="modified-indicator">*</span>}</label>
              @if (c.config?.experimental) {
                <span>🧪️</span>
              }
              @if (modChangesLoaded() && (needsModUpdate(c) || canDiffMod(c))) {
                <span class="update">
                  @if (needsModUpdate(c)) {
                    <span class="fake-link no-select mod-update-link" (click)="updateMod(c)" i18n>🌟️ update</span>
                  }
                  @if (canDiffMod(c)) {
                    <span class="fake-link no-select mod-diff-link" (click)="diffMod(c)" i18n>🔀 diff</span>
                  }
                </span>
              }
            </div>
          }
        }
      </div>
    }

  </form>
  @if (hasLog()) {
    <span class="log mobile-hide">
      <ng-container *ngTemplateOutlet="log" />
    </span>
  }
</div>

<ng-template #log>
  @if (modChangesError().length) {
    <div class="mod-changes-error">
      @for (e of modChangesError(); track $index) {
        <div class="error">{{ e }}</div>
      }
      <div class="error" i18n>Unable to check mods for local changes. Updates and diffs are unavailable.</div>
      <button type="button" class="mod-changes-retry" (click)="loadModChanges()" i18n>retry</button>
    </div>
  }
  @for (e of serverError(); track $index) {
    <div class="error">{{ e }}</div>
  }
  @for (i of installMessages(); track $index) {
    <div>{{ i }}</div>
  }
</ng-template>

<ng-template #mergePopup>
  <div class="merge-popup">
    <div class="merge-popup-header">
      <label class="merge-title">{{ mergeState()!.mod }}</label>
    </div>
    @if (mergeState()!.conflict) {
      <div class="warning merge-warning" i18n>Unable to merge automatically. Review the mod diff or overwrite your local changes.</div>
    } @else {
      <div class="warning merge-warning" i18n>Review the merged mod before saving or overwrite your local changes.</div>
    }
    <app-diff #mergeDiff
              class="mod-merge-diff"
              [original]="mergeState()!.diffBase"
              [modified]="mergeState()!.proposed"
              [fullHeight]="true"
              [resizable]="false" />
    <span><!-- Buttons --></span>
    <span class="buttons right merge-buttons">
      @if (mergeSaving()) {
        <app-loading [inline]="true" />
      }
      <button type="button" [disabled]="mergeSaving()" (click)="applyMerge(mergeDiff.getModifiedContent())" i18n>save</button>
      <button type="button" [disabled]="mergeSaving()" (click)="cancelMerge()" i18n>cancel</button>
    </span>
  </div>
</ng-template>
